module.exports = __webpack_public_path__ + "static/circularstd-bold-74679a4cc017dca4621d6bcf38381806.woff";